
module.exports = function getResource(label, vars = []) {
    let resources = {
        noResults1: 'Nous sommes désolés, aucun produit ne correspond à vos choix de filtres.',
        noResults2: 'Veuillez essayer de modifier certains de vos filtres pour afficher des résultats.'
    };
    return resources[label];
};
